const numberFormats = {
  en: {
    currency: {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 2
    }
  },
  no: {
    currency: {
      style: 'currency',
      currency: 'NOK',
      maximumFractionDigits: 2
    }
  }
}

export default numberFormats
